import {handleMultilingual} from '@wix/wixstores-client-storefront-sdk';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {IWidgetController} from '@wix/native-components-infra/dist/src/types/types';
import {BaseCartController} from './BaseCartController';
import {ControllerConstructorType} from '../../types/app.types';

export interface controllerFactoryParams {
  shouldCallAppSettingsWhenNeeded?: boolean;
}

export const controllerFactory =
  <T extends BaseCartController>(
    ControllerConstructor: ControllerConstructorType<T>,
    {shouldCallAppSettingsWhenNeeded = false}: controllerFactoryParams = {}
  ) =>
  (controllerParams: ControllerParams): IWidgetController => {
    const siteStore = controllerParams?.appData?.context.siteStore;
    let controller: T | undefined;

    return {
      async pageReady() {
        try {
          await siteStore.loadClientConfig();
          controller = new ControllerConstructor(controllerParams);

          const isMultilingualNeeded = () => {
            const multilingualFields = siteStore.getMultiLangFields();
            return (
              controllerParams.controllerConfig.config.externalId &&
              multilingualFields &&
              !multilingualFields?.isPrimaryLanguage
            );
          };

          const shouldCallAppSettings = shouldCallAppSettingsWhenNeeded && isMultilingualNeeded();

          await Promise.all([
            ...(shouldCallAppSettings ? [handleMultilingual(controllerParams, controller.getFreeTexts())] : []),
            controller.init(),
          ]);
          controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void controller.load());
        } catch (error) {
          console.error(error);
          controllerParams.controllerConfig.setProps({generalError: true});
          controllerParams.appData.reportError(error);
        }
      },
      exports() {
        return controller.exports();
      },
      updateConfig: (_$w, updatedConfig: {[key: string]: any}): void => {
        return void controller.onStyleUpdate?.(updatedConfig.style.styleParams);
      },
    };
  };
